import { useEffect, useState } from 'react';

import { useEnumOptions } from '../../../../../common/hooks/useEnumOptions';
import type { ParticipationReportGridContext } from './types';

export const useGridDataContext = () => {
  const { sectors } = useEnumOptions();

  const [gridContext, setGridContext] = useState<ParticipationReportGridContext>({
    sectors,
  });

  useEffect(() => {
    setGridContext(context => ({
      ...context,
      sectors,
    }));
  }, [sectors, setGridContext]);

  return gridContext;
};
